import axiosInstance from './axiosInstance';

const getRewardById = (rewardId) =>
  axiosInstance.get(`/internal/admin/rewards/${rewardId}`);

export default getRewardById;
